// src/pages/ServiceList.tsx - LISTADO DE SERVICIOS
import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, CheckCircle } from 'lucide-react';
import { services } from '../data/services';

const ServiceList: React.FC = () => {
  return (
    <div className="min-h-screen bg-infinity-black">
      {/* Hero Section */}
      <section className="bg-infinity-gradient text-infinity-white py-16">
        <div className="max-w-7xl mx-auto px-4">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">Nuestros Servicios</h1>
          <p className="text-xl">Soluciones integrales en energía renovable para empresas y hogares</p>
        </div>
      </section>

      <div className="max-w-7xl mx-auto px-4 py-16">
        {/* Grid de Servicios */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {services.map((service, index) => (
            <div key={service.id} className={`flex ${index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'} items-center gap-8`}>
              <div className="lg:w-4/10">
                <div className="text-center p-8 bg-infinity-dark rounded-lg shadow-lg">
                    <img src={service.icon} alt={`${service.name} icon`} className="w-full h-full object-cover" />
                </div>
              </div>
              <div className="lg:w-1/2">
                <h3 className="text-3xl font-bold text-infinity-yellow mb-4">{service.name}</h3>
                <p className="text-infinity-white/80 text-lg mb-6">{service.description}</p>
                
                <div className="space-y-3 mb-6">
                  {service.features.slice(0, 4).map((feature, idx) => (
                    <div key={idx} className="flex items-center space-x-3">
                      <CheckCircle size={20} className="text-infinity-yellow flex-shrink-0" />
                      <span className="text-infinity-white/80">{feature}</span>
                    </div>
                  ))}
                  {service.features.length > 4 && (
                    <p className="text-sm text-infinity-white/60 ml-8">Y {service.features.length - 4} beneficios más...</p>
                  )}
                </div>

                <Link
                  to={`/servicios/${service.id}`}
                  className="btn-primary flex items-center space-x-2 w-fit bg-infinity-yellow text-infinity-black hover:bg-infinity-purple hover:text-infinity-white"
                >
                  <span>Ver Detalles</span>
                  <ArrowRight size={20} />
                </Link>
              </div>
            </div>
          ))}
        </div>

        {/* CTA Section */}
        <div className="mt-20 bg-infinity-gradient text-infinity-white rounded-lg p-12 text-center">
          <h2 className="text-4xl font-bold mb-4">
            ¿Listo para comenzar tu proyecto?
          </h2>
          <p className="text-xl text-infinity-white/80 mb-8 max-w-3xl mx-auto">
            Contáctanos hoy mismo y recibe una consulta gratuita para tu proyecto de energía renovable
          </p>
          <Link to="/contacto" className="btn-primary text-lg py-4 px-8 bg-infinity-yellow text-infinity-black hover:bg-infinity-purple hover:text-infinity-white">
            Consulta Gratuita
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ServiceList;